import React from 'react'
import Navbar from '../../Components/Navbar'

function Mens() {
    return (
        <div>
            <Navbar/>
            <h1>Mens.</h1>
        </div>
    )
}

export default Mens
